const style = {
  box: {
    sx: {
      alignItems: 'center',
      display: 'flex',
    },
  },
  avatar: {
    variant: 'circular',
    sx: {
      color: 'primary.main',
      height: 42,
      width: 42,
    },
  },
  badge: {
    '& .MuiBadge-badge': {
      right: -40,
      top: 20,
      padding: '0 4px',
    },
  },
  rowBox: {
    sx: {
      ml: 1,
      width: 120,
    },
    textFirst: {
      variant: 'subtitle2',
    },
    textSecond: {
      color: 'textSecondary',
      variant: 'body2',
    },
  },
  chip: {
    variant: 'outlined',
  },
  matchChip: {
    sx: {
      minWidth: 0.6,
    },
  },
} as const;

export default style;
